module.exports = __webpack_public_path__ + "img/products9.8dd410f9.jpg";